import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../utils/utils';
import { OshCreateWavePopupComponent } from './createwavepopup/createwavepopup.component';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { OshWave } from '../../../../../interfaces/osh/oshWave';

@Component({
    selector: 'osh-wave',
    templateUrl: './wave.component.html',
    styleUrls: ['./wave.component.less',
        '../oshadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class OshWaveComponent implements OnInit {

    @Output() selectedWaveEmit = new EventEmitter<OshWave>();

    subscriptions: any[] = [];
    public dataSource = new MatTableDataSource<any>();
    columnsToDisplay = ['Select', 'Name', 'Description', 'StartDate', 'EndDate', 'actions'];

    selectedWave: OshWave;

    constructor(
        private readonly http: HttpClient
        , private readonly dialogForm: MatDialog
        , @Inject('BASE_URL') private readonly baseUrl: string
        , public defaults: DefaultValuesService
        , private readonly toastrService: ToastrService
        , private readonly customDialog: CustomDialogService) {
        this.selectedWave = this.getDefaultWave();
    }

    ngOnInit(): void {

        if (!this.defaults.isMersyAdminSafetySystemExcellence)
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        this.getWaves();
    }

    getWaves() {
        Utils.httpGetOshWaves(
            this.http,
            this.baseUrl,
            this,
            function (tthis: OshWaveComponent, list: any) {
                tthis.dataSource.data = list
            },
            null
        )
    }

    resetSelectedWave() {
        this.selectedWave = this.getDefaultWave();
    }

    private getDefaultWave(): OshWave {
        return {
            id: -1,
            name: '',
            changedBy: '',
            isActive: false
        };
    }

    onEditWave(element: OshWave) {
        const dialog = this.dialogForm.open(OshCreateWavePopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: element,
        })

        dialog.afterClosed().subscribe(() => {
            this.getWaves()
        })
    }

    openCreateWavePopup() {
        const dialog = this.dialogForm.open(OshCreateWavePopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
        })

        dialog.afterClosed().subscribe(() => {
            this.getWaves()
        })
    }

    onSelectWave(element: OshWave) {
        if (this.selectedWave?.id === element.id)
            this.resetSelectedWave()
        else
            this.selectedWave = element;
        this.selectedWaveEmit.emit(this.selectedWave);
    }

    onRemoveWave(element: OshWave) {
        this.customDialog.openConfirm({
            title: 'Delete Wave',
            message: `Are you sure you want to delete the wave "${element.name}"?`,
            caller: this
        });

        this.customDialog.confirmed().subscribe(res => {
            if (!res?.confirmed)
                return;

            Utils.httpDeleteOshWaves(
                this.http,
                this.baseUrl,
                element.id,
                this,
                function (tthis: OshWaveComponent, resp: any) {
                    if (resp) {
                        tthis.toastrService.success('Wave was deleted successfully!', `Delete ${element.name}`)
                        tthis.getWaves()
                    } else {
                        tthis.toastrService.error('Wave deletion failed!', `Delete ${element.name}`);
                    }
                },
                function (tthis: OshWaveComponent, error: string) {
                    tthis.toastrService.error('Wave deletion failed!', `Delete ${element.name}`);
                }
            )
        });
    }
}